<footer class="footer">
    <div class="wrapper">
        <ul class="p-0">
            <li>
                <a href="https://www.eastsussex.gov.uk/contactus">
                    Contact us
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/about-this-site">
                    About this site
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/about-this-site/accessibility-statement">
                    Accessibility statement
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/contactus/bsl-intro">
                    British Sign Language (BSL) introduction to our website
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/about-this-site/cookies">
                    Cookies
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/privacy/all-privacy-notices">
                    Privacy
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/xmlsitemap">
                    Search Engine Site Map
                </a>
            </li>
            <li>
                <a href="https://www.eastsussex.gov.uk/your-council/about/key-documents/modern-slavery">
                    Modern Slavery Statements
                </a>
            </li>
        </ul>

        <ul class="social-media">
            <li><a href="https://twitter.com/eastsussexcc" aria-label="social media X"><fa-icon
                        [icon]="faX"></fa-icon></a>
            </li>
            <li><a href="https://www.facebook.com/EastSussexCC/" aria-label="social media facebook"><fa-icon
                        [icon]="faFacebook"></fa-icon></a></li>
            <li><a href="https://www.linkedin.com/company/eastsussex-county-council/"
                    aria-label="social media linkedin"><fa-icon [icon]="faLinkedIn"></fa-icon></a></li>
            <li><a href="https://www.youtube.com/user/EastSussexCC" aria-label="social media youtube"><fa-icon
                        [icon]="faYoutube"></fa-icon></a></li>
            <li><a href="https://www.instagram.com/your_east_sussex" aria-label="social media instagram"><fa-icon
                        [icon]="faInstagram"></fa-icon></a></li>

        </ul>
    </div>
</footer>